<template>
    <c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <m-search ref="search" @search="searchHandle">
            <m-search-item label="记录单号">
                <c-input name="record_number"></c-input>
            </m-search-item>
            <m-search-item label="收支类型">
                <c-select name="income_expenses" :options="INCOME_EXPENSES"></c-select>
            </m-search-item>
            <m-search-item label="业务单号">
                <c-input name="docket_number"></c-input>
            </m-search-item>
            <m-search-item label="账单类型">
                <c-input name="trans_type"></c-input>
            </m-search-item>

            <m-search-item label="记录时间" colspan="2">
                <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
            </m-search-item>
        </m-search>

        <m-operate>
            <c-button prepend-icon="tf-export" @click="exportRecord">导出明细</c-button>
        </m-operate>

        <c-table ref="recordList">
            <c-table-column
                    label="记录单号"
                    name="record_number"
                    width="165"
            >
            </c-table-column>

            <c-table-column
                    label="收支状态"
                    name="audit_state"
                    width="90"
            >
                <template #default="{data}">
                    <c-state async dict="TRANS_STATE" :value="data.trans_state"></c-state>
                </template>
            </c-table-column>

            <c-table-column
                    name="income_expenses"
                    label="收支类型"
                    width="90"
            >
                <template #default="{data}">
                    <c-state  async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
                </template>
            </c-table-column>

            <c-table-column
                    label="收支金额"
                    name="money"
                    width="90"
            >
                <template #default="{data}">
                    ￥{{data.money}}
                </template>
            </c-table-column>

<!--            <c-table-column
                    label="变更后余额"
                    name="surplus_money"
                    width="90"
            >
                <template #default="{data}">
                    ￥{{data.surplus_money}}
                </template>
            </c-table-column>-->

            <c-table-column
                    label="业务单号"
                    name="docket_number"
                    width="140"
            >
            </c-table-column>

            <c-table-column
                    label="账单类型"
                    name="trans_type"
                    width="140"
            >
            </c-table-column>

            <c-table-column
                    label="记录时间"
                    name="create_date"
                    width="140"
            >
            </c-table-column>

            <c-table-column
                    label="备注"
                    name="remark"
                    width="500"
            >
            </c-table-column>
        </c-table>

        <!-- 金额汇总：后端对符合筛选口径的全量数据聚合（全局口径），与当页分页无关 -->
        <div class="summary-bar flex-start-center">
            <span class="summary-item">收入合计<span class="summary-value income">￥{{ formatMoney(summary.income_money) }}</span></span>
            <span class="summary-item">支出合计<span class="summary-value expense">￥{{ formatMoney(summary.expense_money) }}</span></span>
            <span class="summary-item">净额<span class="summary-value net">￥{{ formatMoney(summary.net_money) }}</span></span>
        </div>
    </c-dialog>
</template>

<script>

import {mapState} from "vuex";
import {asyncMapState} from '@/store'

export default {
    name: 'accountRecordList',


    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
        ...asyncMapState(['INCOME_EXPENSES'])
    },

    props: {

    },

    data() {
        return {
            account_type: 1,//账户类型：1=通联余额账户；2=三方余额
            user_type:0,//收支人类型：1=商家主账号 2=商家子账号 3=平台会员
            user_id:0, //收支人ID
            user_realname:'',//收支人姓名（导出文件名用）
            defaultSearchData:{},
            summary:{}//金额汇总（收入合计/支出合计/净额，后端全量口径）
        }
    },

    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            data.account_type = this.account_type||1;
            data.user_id = this.user_id || 0;
            data.user_type = this.user_type;
            data.trans_states = [1,3];//仅展示成功、失败的数据
            //平台会员收支仅查询指定类型【回收货款】【退库扣款】【提现】
            if (this.user_type == 3){
                data.trans_types = ['回收交易','账户提现','采购退库'];
            }
            this.$refs.recordList.load({
                url: '/account/record/list',
                data
            });
            //金额汇总与列表同筛选口径：后端对全量数据聚合，随搜索条件联动刷新
            this.loadSummary(Object.assign({}, data));
        },
        /********金额汇总（符合筛选口径的全量数据聚合，与分页无关）************/
        loadSummary(data){
            this.request({
                url: '/account/record/summary',
                data,
                success: res => {
                    this.summary = res || {};
                }
            });
        },
        /**
         * 金额格式化（统一按数值保留两位小数）
         */
        formatMoney(val) {
            if (val === undefined || val === null || val === '') {
                return '0.00';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0.00' : num.toFixed(2);
        },
        /********导出明细（筛选口径与当前列表一致）************/
        exportRecord() {
            var search = this.$refs.search ? this.$refs.search.get() : {};
            var data = Object.assign({}, search);
            data.account_type = this.account_type||1;
            data.user_id = this.user_id || 0;
            data.user_type = this.user_type;
            data.user_realname = this.user_realname;
            data.trans_states = [1,3];//仅导出成功、失败的数据
            //平台会员收支仅查询指定类型【回收货款】【退库扣款】【提现】
            if (this.user_type == 3){
                data.trans_types = ['回收交易','账户提现','采购退库'];
            }
            this.request({
                url: '/account/record/export/url',
                data,
                success: res => {
                    if (res && res.url) {
                        //后端返回相对路径，须走全局 download 拼 baseUrl 取流；window.open 会落到前端域渲染成商家端页面
                        this.download({
                            fileName: res.filename,
                            url: res.url,
                            loading: {
                                message: '正在导出收支记录...'
                            }
                        });
                    }
                }
            });
        },
        open(data) {
            //清空搜索条件
            this.$refs.search.clear();
            this.account_type = data.account_type||1;
            this.user_id = data.user_id || 0;
            this.user_type = data.user_type || 0;
            this.user_realname = data.user_realname || '';
            this.searchHandle();
            this.$refs.dialog.open({
                title: data.title
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .summary-bar {
        flex-shrink: 0;
        gap: 32px;
        border-top: 1px solid #F5F5F5;
        padding: 10px 16px;
        font-size: 13px;
        color: #666;

        .summary-item {
            display: inline-flex;
            align-items: baseline;

            .summary-value {
                margin-left: 6px;
                font-size: 16px;
                font-weight: bold;

                &.income {
                    color: #67C23A;
                }

                &.expense {
                    color: #F56C6C;
                }

                &.net {
                    color: #2563eb;
                }
            }
        }
    }

    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>